<!-- forms represent a list of forms that have been sendout / filled in by a user -->

<template>
<div>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          :color="app.color"
        >
        <v-layout wrap slot="header">
        <v-flex sm6 xs12
        >
          <span class="title">Formulieren</span><br> 
          <span class="body-1">{{user.organisation.name}}</span> 
        </v-flex>
        <v-flex sm6 xs12
        >
              <v-text-field
                append-icon="mdi-magnify"
                single-line=""
                color="white"
                hide-details=""
                v-model="search"
                ></v-text-field>
            </v-flex>
        </v-layout>


        <v-tabs
          class="pt-4"
          :slider-color="app.color"
          v-model="tab">
            <v-tab>Openstaand</v-tab>
            <v-tab>Verwerkt</v-tab>
            <v-tab>Templates</v-tab>
    
            <v-spacer></v-spacer>

          <forms-add-form></forms-add-form>
          
        </v-tabs>

          <v-data-table
              :headers="headers"
              :items="filteredForms()"
              :search="search"
              :footer-props="{
                itemsPerPageText: ''
              }">
            >
              <template v-slot:no-data>
                <v-layout row justify-center="" class="pa-4">
                  Geen formulieren gevonden
                </v-layout>
              </template>

              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template
                v-slot:item="props"
              >
              <v-slide-x-transition>
                <tr class="selectorRow">

                  <td>
                    <v-tooltip right="" dark>
                      <template #activator='data'>
                        <v-avatar v-on="data.on" size="32" :color="props.item.status.color" small>
                          <span class="white--text">{{props.item.created_by.initials}}</span>
                        </v-avatar>
                      </template>
                      <span class="caption">{{props.item.created_date | created}}</span><br>
                      <span class="caption">{{props.item.created_by.full_name}}</span><br>
                      <span class="caption">{{props.item.status.title}}</span>
                      

                    </v-tooltip>
                  </td>

                  <td @click="toForm(props.item.reference)">
                    <span>{{props.item.parent_object.details.name}}</span><br>
                  </td>
                  <td @click="toForm(props.item.reference)">
                    <span>{{props.item.template.name}}</span><br>
                  </td>
                  <td @click="toForm(props.item.reference)">
                    <span>{{props.item.user.email}}</span><br>
                  </td>
    
                  <td>
                    <v-layout>
                      <v-icon @click="showArchiveDialog({type:'form',description:props.item.template.name, reference:props.item.reference})" size="22" id="delete">mdi-delete</v-icon>
                    </v-layout>
                  </td>                                         
                </tr>
              </v-slide-x-transition>

              <dialog-delete></dialog-delete>
              
              </template>
  
            </v-data-table>


      </material-card>

      </v-flex>
      <v-flex
        md12
      >
      </v-flex>
    </v-layout>
  </v-container>

  <dialog-delete></dialog-delete>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";

export default {
  filters: {
    created(date) {
      moment.locale("nl");
      return moment(date).format("LLL");
    }
  },
  data: () => ({
    tab: 0,
    search: "",
    archived: {
      show: "",
      description: "",
      reference: ""
    },
    headers: [
      {
        sortable: false,
        text: "",
        value: ""
      },
      {
        sortable: false,
        text: "Betreft",
        value: "parent_object.details.name"
      },
      {
        sortable: false,
        text: "Formulier",
        value: "template.name"
      },
      {
        sortable: false,
        text: "Invuller",
        value: "user.email"
      }
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10 // -1 for All
    }
  }),
  methods: {
    ...mapActions(["getForms", "checkAuth", "getFormTemplates"]),
    ...mapMutations(["showArchiveDialog"]),
    toForm(reference) {
      this.$store.dispatch("toForm", {
        reference: reference
      });
    },
    filteredForms() {
      if (this.tab == 1) {
        return this.forms.filter(item => item.processed == true);
      } else {
        return this.forms.filter(item => item.processed == false);
      }
    }
  },

  computed: {
    ...mapState(["user", "app", "forms", "contracts"])
  },
  created() {
    this.checkAuth();
    this.getForms();
    this.getFormTemplates();
  },
  watch: {
    tab() {
      if (this.tab == 2) {
        this.$router.push("/formulieren/edit/");
      }
    }
  }
};
</script>

<style scoped>
#delete {
  color: grey;
}
#delete:hover {
  color: #d3223c;
}
</style>

